export function getMapLayersSessionKey(projectId: string) {
  return `map-layers::${projectId}`;
}
